export const calculateChildQuestionOptionName = (questionId, questions) => {
    let questionName = '';
    questions.forEach(question => {
       question.options.forEach(option => {
           option.childQuestionIds.forEach(childQuestionId => {
               if(childQuestionId === questionId){
                   questionName = option.name;
                   if(question.inputType === 'calendar'){
                       questionName = 'calendar conditions';
                   }
               }
           })
       })
    });
    return questionName;
};